function Benin({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_521_655)">
        <path d="M10.4348 14.6089L11.8261 31.449C13.1569 31.8077 14.5558 32.0002 16 32.0002C24.8365 32.0002 32 24.8367 32 16.0002L10.4348 14.6089Z" fill="#D80027"/>
        <path d="M10.4348 16L11.8261 0.551188C13.1569 0.1925 14.5558 0 16 0C24.8365 0 32 7.1635 32 16H10.4348Z" fill="#FFDA44"/>
        <path d="M0 16.0001C0 23.3925 5.01381 29.6129 11.8261 31.4489V0.55127C5.01381 2.38727 0 8.60765 0 16.0001Z" fill="#6DA544"/>
      </g>
    </svg>
  `;

  return baseXml;
}

export default Benin;
